import { Criteria, getDefaultCriteria } from "@/types/criteria";
import { supabase } from "@/integrations/supabase/client";

/**
 * Load evaluation criteria from database (global settings).
 * Falls back to localStorage if database is empty.
 * Returns only active criteria.
 */
export async function loadGlobalCriteria(): Promise<Criteria[]> {
  const defaults = getDefaultCriteria();
  
  try {
    // Try to load from database first (global settings)
    const { data, error } = await supabase
      .from('evaluation_criteria_settings')
      .select('criteria')
      .eq('id', 'global')
      .maybeSingle();
    
    if (!error && data?.criteria && Array.isArray(data.criteria) && data.criteria.length > 0) {
      // Use database criteria
      const dbCriteria = data.criteria as unknown as Criteria[];
      return dbCriteria
        .filter((c: Criteria) => c.active)
        .map((c: Criteria) => {
          const defaultCriterion = defaults.find(d => d.key === c.key);
          return {
            ...c,
            description: c.description || defaultCriterion?.description || "Keine Beschreibung verfügbar.",
            icon: defaultCriterion?.icon
          };
        });
    }
  } catch (e) {
    console.error("Error loading criteria from database:", e);
  }
  
  // Fallback to localStorage if database is empty or error
  const storedCriteria = localStorage.getItem("criteria");
  
  if (storedCriteria) {
    const parsed = JSON.parse(storedCriteria);
    return parsed
      .filter((c: Criteria) => c.active)
      .map((c: Criteria) => {
        const defaultCriterion = defaults.find(d => d.key === c.key);
        return {
          ...c,
          description: c.description || defaultCriterion?.description || "Keine Beschreibung verfügbar.",
          icon: defaultCriterion?.icon
        };
      });
  }
  
  // No stored criteria - use defaults (all active by default)
  return defaults.filter(c => c.active);
}
